import React, { useEffect, useState } from 'react'
import './MenuIcons.scss'
import { UserIcon, DocumentIcon, SearchIcon } from '../utils/icons';
import { NavLink, useLocation } from 'react-router-dom';
import { connect } from 'react-redux'
import * as _ from 'lodash'
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody';
import { showSearch } from '../actions'

const MenuIcons = (props) => {
    const { userActive, closeDrawer } = props
    const location = useLocation();

    const handleClickShowSearch = () => {
        props.showSearch(true)
        useActiveDesactiveSrollBody(true)
        handleClickCloseMenu()
    }

    const handleClickCloseMenu = () => {
        closeDrawer(false)
    }

    return (
        <div className="icons-container">
            <div className="icons-content">
                <div className="icon-item">
                    {
                        location.pathname.indexOf('/presupuesto') === -1 ?
                            <NavLink className={({ isActive }) => (isActive ? 'pointer is-active' : 'pointer')} to="/presupuesto" onClick={handleClickCloseMenu}>
                                {props.budget.length > 0 &&
                                    <div className="number">
                                        <p>{props.budget.length}</p>
                                    </div>
                                }
                                <DocumentIcon size={25} />
                            </NavLink>
                            :
                            <a onClick={handleClickCloseMenu}>
                                {props.budget.length > 0 &&
                                    <div className="number">
                                        <p>{props.budget.length}</p>
                                    </div>
                                }
                                <DocumentIcon size={25} />
                            </a>
                    }
                </div>
                <div className="icon-item right-divider"></div>
                {!_.isEmpty(userActive) &&
                    <div className="icon-item">
                        {
                            location.pathname.indexOf('/usuario') === -1 ?
                                <NavLink className={({ isActive }) => (isActive ? 'pointer is-active' : 'pointer')} to="/usuario" onClick={handleClickCloseMenu}><UserIcon size={25} /></NavLink>
                                :
                                <a className="pointer" onClick={handleClickCloseMenu}><UserIcon size={25} /></a>
                        }
                    </div>
                }
                {_.isEmpty(userActive) &&
                    <div className="icon-item">
                        {
                            location.pathname.indexOf('/acceso') === -1 ?
                                <NavLink className={({ isActive }) => (isActive ? 'pointer is-active' : 'pointer')} to="/acceso" onClick={handleClickCloseMenu}><UserIcon size={25} /></NavLink>
                                :
                                <a className="pointer" onClick={handleClickCloseMenu}><UserIcon size={25} /></a>
                        }
                    </div>
                }
                <div className="icon-item right-divider"></div>
                <div className="icon-item pointer" onClick={handleClickShowSearch}><SearchIcon size={25} /></div>
            </div>
        </div>
    )
}

const mapStateToProps = state => state

const mapDispatchToProps = {
    showSearch
}
export default connect(mapStateToProps, mapDispatchToProps)(MenuIcons)
